var React = require('react');

function PigTailInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_33","data-name":"Path 33","d":"M1040.845,1217.836c-9.083,0-13.655-3.5-13.655-8s6.318-4.881,6.612-.631-1.992,6.862-6.868,7.746-6.739-1.143-6.739-1.143","transform":"translate(-1019.459 -1205.232)","fill":"none","stroke":"#fff","strokeWidth":"2"}));
}

PigTailInline.defaultProps = {"width":"21.387","height":"13.604","viewBox":"0 0 21.387 13.604"};

module.exports = PigTailInline;

PigTailInline.default = PigTailInline;
